import http from "../utils/http"

/**
 * 樓層
 * @param {object} params
 */
export function floors(params) {
    return http({
        url: "/api/pc/floors",
        data: params
    })
}

/**
 * 獲取熱門搜索關鍵詞
 */
export function apiHotSearchWords(params) {
    return http({
        url: "/api/pc/hotSearchWords",
        data: params
    })
}

/**
 * 獲取默認搜索關鍵詞
 */
export function apiDefaultSearchWords(params) {
    return http({
        url: "/api/pc/defaultSearchWords",
        data: params
    })
}
/**
 * 獲取首頁浮層
 */
export function floatLayer(params) {
    return http({
        url: "/api/pc/floatLayer",
        data: params
    })
}
